<template>
  <div class="pb-2">
    <div v-if="this.loadpage == false" class="text-center">
      <b-spinner
        style="width: 5rem; height: 5rem;"
        variant="primary"
        label="Large Spinner"
      />
    </div>
    <div v-if="this.loadpage == true">
      <b-card>
        <b-row>
          <b-col cols="12">
            <b-form-group  class="font-weight-slim" label="Invoice :" label-cols-md="2">
              <div class="align-items-center">
                <b-form-file
                  v-model="invoiceFile"
                  placeholder="Choose a file"
                  drop-placeholder="Drop file here..."
                  class="col-md-5"
                />
              </div>
              <small v-if="this.rowID != null">ไฟล์เดิม <b-link :href="this.currFile_1" target="_blank">คลิก</b-link></small>
            </b-form-group>
          </b-col>
          <b-col cols="12">
            <b-form-group  class="font-weight-slim" label="Packing List :" label-cols-md="2">
              <div class="align-items-center">
                <b-form-file
                  v-model="packingFile"
                  placeholder="Choose a file"
                  drop-placeholder="Drop file here..."
                  class="col-md-5"
                />
              </div>
              <small v-if="this.rowID != null">ไฟล์เดิม <b-link :href="this.currFile_2" target="_blank">คลิก</b-link></small>
            </b-form-group>
          </b-col>
          <b-col cols="12">
            <b-form-group class="font-weight-slim" label="บริษัท :" label-cols-md="2">
              <div class="d-flex align-items-center">
                <v-select class="px-0 col-12 col-md-5" v-model="companySel" :options="companyList" label="companyName" @input="changeCompany"/>
              </div>
            </b-form-group>
          </b-col>
          <b-col cols="12" v-if="this.companySel != null && this.companySel.rowID != 0">
            <b-form-group class="font-weight-slim" label="ที่อยู่ :" label-cols-md="2">
              <div class="align-items-center">
                <b-form-Textarea class="col-md-5" v-model="companyAddress"/>
              </div>
            </b-form-group>
          </b-col>
          <b-col cols="12" v-if="this.companySel != null && this.companySel.rowID != 0">
            <b-form-group  class="font-weight-slim" label="รหัสไปรษณีย์/ตำบล/อำเภอ/จังหวัด :" label-cols-md="2">
              <div class="d-flex align-items-center">
                <v-select  class="px-0 col-12 col-md-5" v-model="postcodeSel" :options="postcodeMapping" label="list"/>
              </div>
            </b-form-group>
          </b-col>
          <b-col cols="12">
            <b-form-group class="font-weight-slim" label="ขนส่ง :" label-cols-md="2">
              <div class="d-flex align-items-center">
                <v-select class="px-0 col-12 col-md-5" v-model="expressSel" :options="expressList" label="description"/>
              </div>
            </b-form-group>
          </b-col>
          <b-col cols="12" v-if="this.expressSel != null && this.expressSel.rowId == 11">
            <b-form-group class="font-weight-slim" label="ชื่อขนส่ง :" label-cols-md="2">
              <div class="align-items-center">
                <b-form-input class="col-md-5" v-model="otherExpress"/>
              </div>
            </b-form-group>
          </b-col>
          <b-col cols="12">
            <b-form-group class="font-weight-slim" label="รูปแบบการจัดส่ง :" label-cols-md="2">
              <div class="align-items-center">
                <b-form-radio-group
                  v-model="transportSel"
                  :options="transportList"
                />
              </div>
            </b-form-group>
          </b-col>
          <b-col cols="12">
            <b-form-group class="font-weight-slim" label="ตีลัง :" label-cols-md="2">
              <div class="align-items-center">
                <b-form-radio-group
                  v-model="makeBox"
                  :options="makeBoxList"
                />
              </div>
            </b-form-group>
          </b-col>
          <b-col cols="12">
            <b-form-group class="font-weight-slim" label="ขอ Form E :" label-cols-md="2">
              <div class="align-items-center">
                <b-form-radio-group
                  v-model="formE"
                  :options="formEList"
                />
              </div>
            </b-form-group>
          </b-col>
          <b-col cols="12">
            <b-form-group class="font-weight-slim" label="Tax Refund :" label-cols-md="2">
              <div class="align-items-center">
                <b-form-radio-group
                  v-model="taxRefund"
                  :options="taxRefundList"
                />
              </div>
            </b-form-group>
          </b-col>
          <b-col cols="12">
            <b-form-group class="font-weight-slim" label="ชื่อใบขนสินค้า :" label-cols-md="2">
              <div class="align-items-center">
                <b-form-radio-group
                  v-model="transOwnName"
                  :options="transOwnNameList"
                />
              </div>
            </b-form-group>
          </b-col>
        </b-row>
        <div class="text-right">
          <b-button variant="primary" :disabled="this.loadButton == false" @click="actionImportList">
            <b-spinner v-if="this.loadButton == false" small/>
            บันทึก
          </b-button>
        </div>
      </b-card>
    </div>
  </div>
</template>

<script>
import {
  BRow, BCol, BButton, BCard, BCardHeader, BCardBody, BModal, VBToggle, BAvatar, BContainer, BLink, BTable,
  BSpinner, BImg, BFormCheckbox, BTooltip, BFormRadioGroup, BFormRadio, BFormGroup, BForm, BFormFile,
  BFormInput, VBModal, BFormTextarea, BCollapse
} from 'bootstrap-vue'
import flatPickr from 'vue-flatpickr-component'
import vSelect from 'vue-select'
import AppTimeline from '@core/components/app-timeline/AppTimeline.vue'
import AppTimelineItem from '@core/components/app-timeline/AppTimelineItem.vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { format_price, formatDatetime} from '@/views/global_function.js'
import axios from "axios";
import {header_token} from '@/views/token.js'
import {taobaoService_dotnet} from '@/views/global.js'
export default {
  name: 'Taobao2youActionList',

  directives: {
    'b-toggle': VBToggle,
    'b-modal': VBModal
  },

  components: {
    BRow, BCol, BButton, BCard, BCardHeader, BCardBody, BModal, VBToggle, BAvatar, BContainer, BLink, BTable,
    BSpinner, BImg, BFormCheckbox, BTooltip, BFormRadioGroup, BFormRadio, BFormGroup, BForm, BFormFile, BFormInput,
    flatPickr, vSelect, BFormTextarea, BCollapse,

    AppTimeline, AppTimelineItem
  },

  data() {
    return {
      //popup
      rowID: null,
      invoiceFile: null,
      packingFile: null,
      currFile_1: '',
      currFile_2: '',

      postcodeSel: null,
      postcodeMapping:[],

      companySel: { companyName: '--เลือกบริษัท--', 'rowID': 0 },
      companyList:[],

      companyAddress: '',

      expressSel: { description: '--เลือกขนส่ง--', 'rowId': 0 },
      expressList: [],

      otherExpress: '',

      transportSel: null,
      transportList: [],

      makeBox: false,
      makeBoxList: [
        { text: 'ไม่ตีลังไม้', value: false },
        { text: 'ตีลังไม้', value: true },
      ],

      formE: true,
      formEList: [
        { text: 'ขอ Form E', value: true },
        { text: 'ไม่ขอ Form E', value: false },
      ],

      taxRefund: false,
      taxRefundList: [
        { text: 'ไม่ต้องทำ Tax Refund', value: false },
        { text: 'ทำ Tax Refund', value: true },
      ],

      transOwnName: true,
      transOwnNameList: [
        { text: 'ต้องการทำใบขนสินค้าเป็นชื่อตัวเอง', value: true },
        { text: 'ไม่ต้องการทำใบขนสินค้าเป็นชื่อตัวเอง', value: false },
      ],

      //load
      loadpage: true,
      loadButton: true
    };
  },

  async created() {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const rowID = await parseInt(urlParams.get('rowID'))
    await this.getPostcode()
    await this.getTransportType()
    await this.getExpress()
    await this.getCompany()
    if (rowID != 0) {
      await this.getImportList(rowID)
    }
  },

  methods: {
    async changeCompany () {
      if (this.companySel != null && this.companySel.rowID != 0) {
        this.companyAddress = this.companySel.address
        this.postcodeSel = this.postcodeMapping.filter(x => x.rowID == this.companySel.postcodeMappingID)[0]
      } else {
        this.companyAddress = ''
        this.postcodeSel = null
      }
    },
    async getPostcode(){
      if (JSON.parse(localStorage.getItem('postcode'))) {
        this.postcodeMapping = JSON.parse(localStorage.getItem('postcode'))
      } else {
        let response = await axios.get(
          taobaoService_dotnet + 'app/Customer/get-postcode-mapping',
          { headers: header_token }
        );
        response.data.forEach((e) => {
          this.postcodeMapping.push(
            {
              'list': e.postcode + " / " + e.subDistrict + " / " + e.district + " / " + e.province,
              'provinceID': e.provinceID,
              'rowID': e.rowID,
              'subDistrict': e.subDistrict,
              'district': e.district,
              'province': e.province,
              'postcode': e.postcode,
            }
          )
        })
        localStorage.setItem('postcode', JSON.stringify(this.postcodeMapping ))
      }
    },
    async getTransportType() {
      let response = await axios.get(
        taobaoService_dotnet + '/app/order/get-transport-type' ,
        { headers: header_token }
      );
      response.data.forEach((e) => {
        this.transportList.push({
          'text': e.descriptionTH,
          'value': e.id
        })
      })
    },
    async getExpress() {
      let response = await axios.get(
        taobaoService_dotnet + 'api/General/get-express' ,
        { headers: header_token }
      );
      this.expressList = response.data
    },
    async getCompany() {
      let response = await axios.post(
        taobaoService_dotnet + 'app/FileCertificate/get-file-cert',
        // "https://localhost:5001/app/FileCertificate/get-file-cert",
        {
          "customerID": JSON.parse(localStorage.getItem('cusId')),
        },
        { headers: header_token }
      );
      this.companyList = response.data
    },
    async getImportList(id) {
      let response = await axios.post(
        taobaoService_dotnet + 'app/FileCertificate/get-import-once',
        // "https://localhost:5001/app/FileCertificate/get-import-once",
        {
          "customerID": JSON.parse(localStorage.getItem('cusId')),
          "rowID": id
        },
        { headers: header_token }
      );
      if (response.data == '' || response.data.importStatus != 0) {
        return window.open("/import/formal", "_self")
      }
      var  item = response.data
      this.rowID = item.rowID
      this.currFile_1 = item.invoiceFile
      this.currFile_2 = item.packingListFile
      this.companySel = this.companyList.filter( x => x.rowID == item.companyCertID)[0]
      this.postcodeSel = this.postcodeMapping.filter(x => x.rowID == item.postcodeMappingID)[0]
      this.expressSel = this.expressList.filter(x => x.rowId == item.expressCompanyID)[0]
      this.otherExpress = item.expressCompanyID == 11 ? item.otherExpressName : ''
      this.companyAddress = item.address
      this.transportSel = item.transportTypeID
      this.makeBox = item.isMakebox
      this.formE = item.requestFormE
      this.taxRefund = item.requestTaxRefund
      this.transOwnName = item.requestTransportOwnName
    },
    async actionImportList () {
      var pass = false
      if ((this.invoiceFile != null && this.packingFile != null) || this.rowID != null) {
        if (this.companySel != null && this.companySel.rowID != 0 && this.companyAddress != '' && this.postcodeSel != null) {
          if (this.transportSel != null) {
            if (this.expressSel != null && this.expressSel.rowId != 0 && this.expressSel.rowId != 11) {
              pass = true
            } else if (this.expressSel != null && this.expressSel.rowId == 11 && this.otherExpress != '') {
              pass = true
            }
          }
        }
      }

      if (pass == false) {
        this.$swal({
          position: 'top',
          title: 'กรอกข้อมูลไม่ครบ !',
          text: 'กรุณากรอกข้อมูลให้ครบทุกช่อง !',
          icon: 'warning',
          showCancelButton: false,
          confirmButtonText: 'เข้าใจแล้ว',
          customClass: {
            confirmButton: 'btn btn-primary',
            text: 'text-danger'
          },
          buttonsStyling: false,
        })
      } else {
        this.loadButton = false
        var file_1 = ''
        var file_2 = ''
        if (this.invoiceFile != null) {
          file_1 = await this.addPhoto(this.invoiceFile)
        }
        if (this.packingFile != null) {
          file_2 = await this.addPhoto(this.packingFile)
        }
        let response = await axios.post(
          taobaoService_dotnet + 'app/FileCertificate/action-import-list',
          // "https://localhost:5001/app/FileCertificate/action-import-list",
          {
            "rowID": this.rowID,
            "customerID": JSON.parse(localStorage.getItem('cusId')),
            "invoiceFile": file_1 != '' ? file_1 : this.currFile_1,
            "packingListFile": file_2 != '' ? file_2 : this.currFile_2,
            "companyCertID": this.companySel.rowID,
            "address": this.companyAddress,
            "postcodeMappingID": this.postcodeSel.rowID,
            "transportType": this.transportSel,
            "expressCompanyID": this.expressSel.rowId,
            "otherExpressName": this.expressSel.rowId == 11 ? this.otherExpress : null,
            "isMakebox": this.makeBox,
            "requestFormE": this.formE,
            "requestTaxRefund": this.taxRefund,
            "requestTransportOwnName": this.transOwnName
          },
          { headers: header_token }
        );
        if (response.data == 'success') {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'สำเร็จ',
              icon: 'CheckIcon',
              text: 'บันทึกข้อมูลเรียบร้อย',
              variant: 'success',
            },
          },
          {
            position: 'top-center',
          })
          this.clearValue()
        }
        this.loadButton = true
      }
    },
    clearValue() {
      this.rowID = null
      this.invoiceFile = null
      this.packingFile = null
      this.currFile_1 = ''
      this.currFile_2 = ''
      this.postcodeSel = null
      this.companySel = { companyName: '--เลือกบริษัท--', 'rowID': 0 }
      this.companyAddress = ''
      this.expressSel = { description: '--เลือกขนส่ง--', 'rowId': 0 }
      this.otherExpress = ''
      this.transportSel = null
      this.makeBox = false
      this.formE = true
      this.taxRefund = false
      this.transOwnName = true
    },
    async addPhoto(file) {
      var fileLink = null
      var FormData = require('form-data');
      var data = new FormData();
      data.append('', file);
      var config = {
        method: 'post',
        url: taobaoService_dotnet + 'api/General/upload-file-with-type?UploadType=2',
        headers: {
          'Authorization': 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiIwIiwibmFtZSI6InRhb2JhbzJ5b3UiLCJyb2xlIjoiYWRtaW4iLCJjdXN0b21lcmlkIjoiIiwiZXhwIjoxNjI2MTAyNzgwLCJpc3MiOiJ0YW9iYW8yeW91IiwiYXVkIjoiaHR0cHM6Ly93d3cudGFvYmFvMnlvdS5jb20ifQ.gIhTvIMLXxpq6bUFPbp242szDgPRl33SaF3k5f6T3-U',
          'Content-Type': 'application/json',
        },
        data : data
      };
      await axios(config)
      .then(function (response) { fileLink = response.data })
      .catch(function (error) { console.log(error); });
      return fileLink[0]
    }
  },
};
</script>

<style lang="scss" scoped>

</style>